import moment from "moment";
import "moment/locale/de";
import "moment/locale/sr";
import i18n from "../../locales/i18n";

export const formatDate = (date?: string, formatType = "DD.MM.YYYY") => {
  return moment(date).locale(i18n.language).format(formatType);
};
